
export const applicationsData = [
    {
        id: "head-1",
        title: "ФИО",
        icon: "",
        width:  "190px",
    },
    // {
    //     id: "head-2",
    //     title: "Подразделение",
    //     icon: "",
    //     width:  "150px",
    // },
    {
        id: "head-3",
        title: "ПРИЧИНА ОТСУТСТВИЯ",
        width: "150px",
    },
    {
        id: "head-4",
        title: "Дата и время начала отсутствия",
        icon: "",
        width:  "150px",
    },
    {
        id: "head-8",
        title: "Дата и время возвращения на работу",
        icon: "",
        width:  "150px",
    },
    {
        id: "head-5",
        title: "комментарий для руководителя ",
        icon: "",
        width:"170px",
    },
    {
        id: "head-6",
        title: "Статус",
        icon: "",
        width:  "100px",
    },

    {
        id: "head-7",
        title: "  ",
        icon: "",
        width: "66px",
    },
];
